import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MetaTags } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class MetaService {
  private readonly meta: Meta = inject(Meta);
  private readonly title: Title = inject(Title);

  /**
   * Set meta tags and title
   * @param tags meta tags
   */
  public setMeta(tags: MetaTags): void {
    this.setTitle(tags.title);
    this.setMetaTags(tags);
  }

  /**
   * Set meta tags
   * @param tags meta tags
   */
  private setMetaTags(tags: MetaTags): void {
    Object.keys(tags).forEach((key: string) => {
      this.meta.updateTag({ name: key, content: tags[key] });
    });
  }

  /**
   * Set page title
   * @param title page title
   */
  private setTitle(title: string): void {
    this.title.setTitle(title);
  }
}
